module.exports = __webpack_public_path__ + "img/coca-cola-logo.69458541.svg";